/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetReceiptRequest} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'
import {GetReceiptResponse} from '@cash-web/protos/squareup/cash/payback/api/Service.pb'


export const getPaymentReceipt = (request: GetReceiptRequest, options?: CashRequestOptions) => post<GetReceiptRequest, GetReceiptResponse>("/2.0/cash/get-payment-receipt", request, {...options, rejectOnError: true })